import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  getReversedLangDefinition,
  makeUrlWithLang
} from '../../utils/helpers';

class ChangeLang extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  static propTypes = {
    t: PropTypes.func,
    i18n: PropTypes.object,
    className: PropTypes.string
  };

  handleClick() {
    const { language } = this.props.i18n;
    const { pathname, host, protocol, search } = window.location;
    const newLocation = makeUrlWithLang({
      protocol: protocol.substring(0, protocol.length - 1),
      host,
      path: `${pathname}${search}`,
      lang: getReversedLangDefinition(language)
    });

    window.location.replace(newLocation);
  }

  render() {
    const {
      t,
      i18n: { language },
      className
    } = this.props;
    const classNames = cn(className, 'lang-switcher');

    return (
      <button
        className={classNames}
        onClick={this.handleClick}
        data-cy="lang-switcher"
      >
        {t('main_menu.lang', { lng: getReversedLangDefinition(language) })}
      </button>
    );
  }
}
export default ChangeLang;
